export const CARD_CLASS_NAME =
  'rounded-md border border-cloudDarker bg-white dark:border-darkCharcoal dark:bg-pebble'

export const SECTION_TITLE_CLASS_NAME =
  'text-xl font-semibold text-gravel dark:text-snow'

export const MUTED_TEXT_CLASS_NAME = 'text-gravel/55 dark:text-rock'

export const MAINTENANCE_TITLE_CLASS_NAME =
  'font-semibold text-sky-700 dark:text-sky-300'
